import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { Member } from "../../../types/employee.types";
import { CommonDetails, EnrollmentSchema, StandardDetails, VEBEnrollmentSchema } from "../../../types/enrollment.types";
import { LogoSettings } from "../../../types/logoSettings.types";
import { OpenEnrollment, VEBOpenEnrollment } from "../../../types/openEnrollment.types";
import { Plan, VEBPlan } from "../../../types/plan.types";
import { Theme } from "../../../types/theme.types";
import { VEBPlanSchema } from "../../../types/VEBPlanSchema";
import { request } from "../api";

const initialRoute = "plan";
const { get } = request;

export const getActiveVEBPlans = async (
	group_number: number | string
): Promise<{
	currentPlans: VEBPlanSchema[];
	futurePlans: VEBPlanSchema[];
}> => {
	try {
		if (!group_number) {
			throw new Error("group_number is required but not provided");
		}

		const endpoint = `${initialRoute}/veb-active-plans/${group_number}`;

		const token = localStorage.getItem("@jwt_member");
		if (!token) throw new Error("JWT token not found");

		const response = await get(endpoint, {
			...headers,
			Authorization: `Bearer ${token}`
		});

		if (response?.data?.message === MESSAGE.get.succ) {
			return response.data.data as {
				currentPlans: VEBPlanSchema[];
				futurePlans: VEBPlanSchema[];
			};
		}

		throw new Error("Failed to fetch active VEB plans");
	} catch (err) {
		console.error("Error in getActiveVEBPlans:", err);
		alert(err);
		throw err;
	}
};
